module.exports = `<svg width="24px" height="18px" viewBox="0 0 24 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.1 (57501) - http://www.bohemiancoding.com/sketch -->
    <title>Artboard 7</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Artboard-7" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="Messages-Inbox" transform="translate(1.000000, 1.000000)" stroke="#5E6D77" stroke-width="1.5">
            <path d="M18.2868,4.83048 L12.2076,9.64248 C11.5572,10.15608 10.6392,10.15968 9.9852,9.65208 L2.9052,4.14408 C2.3616,3.72168 1.626,3.64608 1.0092,3.94728 C0.3912,4.24968 3.41060513e-13,4.87728 3.41060513e-13,5.56368 L3.41060513e-13,14.40048 C3.41060513e-13,15.39408 0.8064,16.20048 1.8,16.20048 L22.2,16.20048 L22.2,2.40048 C22.2,1.40568 21.3936,0.60048 20.4,0.60048 L3.41060513e-13,0.60048" id="Stroke-1"></path>
        </g>
    </g>
</svg>`;
